import React, { lazy } from 'react'
import { Route } from 'react-router-dom';
const AddPerson = lazy(() => import('../pages/Dashboard/AddPerson.js'));
const ChangePassword = lazy(() => import('../pages/Dashboard/ChangePassword.js'));
const PaymentHistory = lazy(() => import('../pages/Dashboard/Payment.js'));
const Setting = lazy(() => import('../pages/Dashboard/Setting.js'));
const AllTeamsDetails = lazy(() => import('../pages/Dashboard/AllTeamsDetails.js'));
const AddTeams = lazy(() => import('../pages/Dashboard/AddTeams.js'));
const RegisterTeam = lazy(() => import('../pages/Payment/RegisterTeam.jsx'));
const AllTeam = lazy(() => import("../pages/Dashboard/AllTeam.js"));
const AddRosterMember = lazy(() => import('../pages/Dashboard/AddRosterMember.js'));
const TeamRoster = lazy(() => import('../pages/Dashboard/TeamRoster.js'));
const ManagerProfile = lazy(() => import('../pages/Dashboard/ManagerProfile.js'));
const TeamStandings = lazy(() => import('../pages/Dashboard/TeamStandings.js'));
   
// inside the fragment:



const ManagerRoutes = (
    <>
        <Route exact path='/dashboard/allteams' element={<AllTeam />}></Route>
        <Route exact path='/dashboard/allteams/:id' element={<AllTeamsDetails />}></Route>
        <Route exact path='/dashboard/addteams' element={<AddTeams />}></Route>
        <Route exact path='/dashboard/payment/history' element={<PaymentHistory />}></Route>
        <Route exact path='/dashboard/addperson' element={<AddPerson />}></Route>
        <Route exact path='/dashboard/user/setting' element={<Setting />}></Route>
        <Route exact path='/dashboard/user/change-password' element={<ChangePassword />}></Route>
        <Route exact path='/dashboard/registerteam/:id' element={<RegisterTeam />}></Route>
        <Route exact path='/dashboard/team/:teamId/add-roster-member' element={<AddRosterMember />}></Route>
        <Route exact path='/dashboard/team/:teamId/roster' element={<TeamRoster />}></Route>
        <Route exact path='/dashboard/manager/profile' element={<ManagerProfile />} />
        <Route exact path='/dashboard/team/:teamId/standings' element={<TeamStandings />} />

    </>
)

export default ManagerRoutes